import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../utils/apollo/api'
import LazySelectAllLinkApollo from '../../components/actions/LazySelectAllLinkApollo'

const QUERY = gql`
  query Statuses($search: String, $filter: ServiceOrderStatusFilter) {
    statuses(limit: 900000, search: $search, filter: $filter) {
      id
    }
  }
`

const SelectAllStatusesLink = ({ search, filter, ...props }) => {
  return (
    <LazySelectAllLinkApollo query={QUERY} variables={{ search, filter }} client={serviceOrdersClient} {...props} />
  )
}

export default SelectAllStatusesLink
